const bspGenerator = {
    namespaced: true,
    mutations: {
        updateGpio(state, v) {
            state.gpio = v;
        },
        toggleLoading(state, v) {
            state.loading = v;
        }
    },
    state: {
        loading: false,
        periph_base: {
            periph_base: "0x00000000",
            ahb1periph_base: "0x00000000",
            ahb2periph_base: "0x00000000"
        },
        gpio: {
            base_addr: {
                gpio0_offset: "0x80005000",
                gpio1_offset: "0x80006000"
            },
            gpio_csr: {
                gpio_ctl_offset: "0x00000000",
                gpio_omode_offset: "0x00000004",
                gpio_pud_offset: "0x00000008",
                gpio_istat_offset: "0x000000C",
                gpio_octl_offset: "0x00000010",
                gpio_bs_offset: "0x00000014",
                gpio_bc_offset: "0x00000018",
            },
            gpio_ct_map: {
                gpio_ctl0: [0, 1],
                gpio_ctl1: [2, 3],
                gpio_ctl2: [4, 5],
                gpio_ctl3: [6, 7],
                gpio_ctl4: [8, 9],
                gpio_ctl5: [10, 11],
                gpio_ctl6: [12, 13],
                gpio_ctl7: [14, 15],
                gpio_ctl8: [16, 17],
                gpio_ctl9: [18, 19],
                gpio_ctl10: [20, 21],
                gpio_ctl11: [22, 23],
                gpio_ctl12: [24, 25],
                gpio_ctl13: [26, 27],
                gpio_ctl14: [28, 29],
                gpio_ctl15: [30, 31],
            },
            gpio_om_map: {
                gpio_om0: [0, 1],
                gpio_om1: [2, 3],
                gpio_om2: [4, 5],
                gpio_om3: [6, 7],
                gpio_om4: [8, 9],
                gpio_om5: [10, 11],
                gpio_om6: [12, 13],
                gpio_om7: [14, 15],
                gpio_om8: [16, 17],
                gpio_om9: [18, 19],
                gpio_om10: [20, 21],
                gpio_om11: [22, 23],
                gpio_om12: [24, 25],
                gpio_om13: [26, 27],
                gpio_om14: [28, 29],
                gpio_om15: [30, 31]
            },
            gpio_istat_map: {
                gpio_istat0: 0,
                gpio_istat1: 1,
                gpio_istat2: 2,
                gpio_istat3: 3,
                gpio_istat4: 4,
                gpio_istat5: 5,
                gpio_istat6: 6,
                gpio_istat7: 7,
                gpio_istat8: 8,
                gpio_istat9: 9,
                gpio_istat10: 10,
                gpio_istat11: 11,
                gpio_istat12: 12,
                gpio_istat13: 13,
                gpio_istat14: 14,
                gpio_istat15: 15
            },
            gpio_pud_map: {
                gpio_pud0: [0, 1],
                gpio_pud1: [2, 3],
                gpio_pud2: [4, 5],
                gpio_pud3: [6, 7],
                gpio_pud4: [8, 9],
                gpio_pud5: [10, 11],
                gpio_pud6: [12, 13],
                gpio_pud7: [14, 15],
                gpio_pud8: [16, 17],
                gpio_pud9: [18, 19],
                gpio_pud10: [20, 21],
                gpio_pud11: [22, 23],
                gpio_pud12: [24, 25],
                gpio_pud13: [26, 27],
                gpio_pud14: [28, 29],
                gpio_pud15: [30, 31],
            },
            gpio_octl_map: {
                gpio_octl0: 0,
                gpio_octl1: 1,
                gpio_octl2: 2,
                gpio_octl3: 3,
                gpio_octl4: 4,
                gpio_octl5: 5,
                gpio_octl6: 6,
                gpio_octl7: 7,
                gpio_octl8: 8,
                gpio_octl9: 9,
                gpio_octl10: 10,
                gpio_octl11: 11,
                gpio_octl12: 12,
                gpio_octl13: 13,
                gpio_octl14: 14,
                gpio_octl15: 15
            },
            gpio_bset_map: {
                gpio_bset0: 0,
                gpio_bset1: 1,
                gpio_bset2: 2,
                gpio_bset3: 3,
                gpio_bset4: 4,
                gpio_bset5: 5,
                gpio_bset6: 6,
                gpio_bset7: 7,
                gpio_bset8: 8,
                gpio_bset9: 9,
                gpio_bset10: 10,
                gpio_bset11: 11,
                gpio_bset12: 12,
                gpio_bset13: 13,
                gpio_bset14: 14,
                gpio_bset15: 15
            },
            gpio_bc_map: {
                gpio_cr0: 0,
                gpio_cr1: 1,
                gpio_cr2: 2,
                gpio_cr3: 3,
                gpio_cr4: 4,
                gpio_cr5: 5,
                gpio_cr6: 6,
                gpio_cr7: 7,
                gpio_cr8: 8,
                gpio_cr9: 9,
                gpio_cr10: 10,
                gpio_cr11: 11,
                gpio_cr12: 12,
                gpio_cr13: 13,
                gpio_cr14: 14,
                gpio_cr15: 15
            }
        },
        usart: {
            base_addr: {},
            addr: "0x80009000",
            instances: [
            ],
            usart_csr: {
                usart_ctl0_offset: "0x00000000",
                usart_ctl1_offset: "0x00000004",
                usart_ctl2_offset: "0x00000008",
                usart_baud_offset: "0x0000000C",
                usart_gp_offset: "0x00000010",
                usart_stat_offset: "0x00000014",
                usart_intc_offset: "0x00000018",
                usart_rdata_offset: "0x00000028",
                usart_tdata_offset: "0x00000024"
            },
            usart_ctl0_map: {
                usart_ctl0_uen: 0,
                usart_ctl0_ren: 1,
                usart_ctl0_ten: 2,
                usart_ctl0_idleie: 3,
                usart_ctl0_rbneie: 4,
                usart_ctl0_tcie: 5,
                usart_ctl0_tbeie: 6,
                usart_ctl0_perrie: 7,
                usart_ctl0_pm: [8, 9],
                usart_ctl0_pcen: 10,
                usart_ctl0_wm: 11,
                usart_ctl0_wl: 12,
                usart_ctl0_amie: 13,
                usart_ctl0_ovsmod: 14
            },
            usart_ctl1_map: {
                usart_ctl1_addm: 0,
                usart_ctl1_lblen: 1,
                usart_ctl1_lbdie: 2,
                usart_ctl1_clen: 3,
                usart_ctl1_cph: 4,
                usart_ctl1_cpl: 5,
                usart_ctl1_cken: 6,
                usart_ctl1_stb: 7,
                usart_ctl1_addr: 8,
                usart_ctl1_msbf: 9
            },
            usart_ctl2_map: {
                usart_ctl2_errie: 0,
                usart_ctl2_iren: 1,
                usart_ctl2_irlp: 2,
                usart_ctl2_hden: 3,
                usart_ctl2_rtsen: 4,
                usart_ctl2_ctsen: 5,
                usart_ctl2_ctsie: 6,
                usart_ctl2_osb: 7
            },
            usart_stat_map: {
                usart_stat_perr: 0,
                usart_stat_ferr: 1,
                usart_stat_nerr: 2,
                usart_stat_orerr: 3,
                usart_stat_idlef: 4,
                usart_stat_rbne: 5,
                usart_stat_tc: 6,
                usart_stat_tbe: 7,
                usart_stat_lbdf: 8,
                usart_stat_ctsf: 9,
                usart_stat_cts: 10,
                usart_stat_bsy: 11,
                usart_stat_amf: 12
            },
            usart_intc_map: {
                usart_intc_pec: 0,
                usart_intc_fec: 1,
                usart_intc_nec: 2,
                usart_intc_orec: 3,
                usart_intc_idlec: 4,
                usart_intc_tcc: 5,
                usart_intc_lbdc: 6,
                usart_intc_ctsc: 7,
                usart_intc_rtc: 8,
                usart_intc_ebc: 9,
                usart_intc_amc: 10,
                usart_intc_wuc: 11,
            },
            usart_baud_map: {
                usart_baud_fradiv: [0, 1, 2, 3],
                usart_baud_intdiv: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
            },
            usart_gp_map: {
                usart_gp_psc: [0, 1, 2, 3, 4, 5, 6, 7],
                usart_gp_guat: [8, 9, 10, 11, 12, 13, 14, 15]
            },
            usart_rdata_map: {
                usart_rdata_rdata: [0, 1, 2, 3, 4, 5, 6, 7]
            },
            usart_tdata_map: {
                usart_tdata_tdata: [0, 1, 2, 3, 4, 5, 6, 7]
            }
        },
        spi: {
            spi_addr: {
                spi0_offset: "0x80007000",
                spi1_offset: "0x80008000"
            },
            spi_csr: {
                spi_ctl0: "0x00000000",
                spi_ctl1: "0x00000004",
                spi_stat: "0x00000008",
                spi_data: "0x0000000C",
                spi_crcpoly: "0x00000010",
                spi_rcrc: "0x00000014",
                spi_tcrc: "0x00000018",
                spi_ct2: "0x00000028",
                spi_psc: "0x00000024"
            },
            spi_ct0_map: {
                spi_ctl0_ckph: 0,
                spi_ctl0_ckpl: 1,
                spi_ctl0_mstmod: 2,
                spi_ctl0_psc: [3, 4, 5],
                spi_ctl0_spien: 1,
                spi_ctl0_lf: 1,
                spi_ctl0_swnss: 1,
                spi_ctl0_swnssen: 1,
                spi_ctl0_ro: 1,
                spi_ctl0_ff16: 1,
                spi_ctl0_crcnt: 1,
                spi_ctl0_crcen: 1,
                spi_ctl0_bdoen: 1,
                spi_ctl0_bden: 1
            },
            spi_ct1_map: {
                spi_ctl1_nssdrv: 1,
                spi_ctl1_nssp: 1,
                spi_ctl1_tmod: 1,
                spi_ctl1_errie: 1,
                spi_ctl1_rbneie: 1,
                spi_ctl1_tbeie: 1
            },
            spi_stat_map: {
                spi_stat_rbne: 1,
                spi_stat_tbe: 1,
                spi_stat_crcerr: 1,
                spi_stat_conferr: 1,
                spi_stat_rxorerr: 1,
                spi_stat_trans: 1,
                spi_stat_ferr: 1,
                spi_stat_bsy: 1
            },
            spi_data_map: {
                spi_data_data: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
            },
            spi_crcpoly_map: {
                spi_crcpoly_crcpoly: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
            },
            spi_rcrc_map: {
                spi_rcrc_rcrc: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
            },
            spi_tcrc_map: {
                spi_tcrc_tcrc: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
            },
            spi_psc_map: {
                spi_psc_div: [0, 1, 2, 3, 4, 5, 6, 7],
                spi_psc_of: 8
            },
            spi_ctl2_map: {
                spi_ctl2_dtlen: [0, 1],
                spi_ctl2_ckpl: 2,
                spi_ctl2_sel: 3
            }
        },
        test_app: {
            clint_test: 1,
            gpio_test: 1,
            usart_test: 1,
            dmwr_test: 1
        }
    }
}

export default bspGenerator
